import Service from "../../Services";
import * as moment from "moment";
import { DateFormatUtil } from "../../util/DateFormatUtil"
const Article = {
    namespaced: true,
    state: {
        allArticles: null,
        allEbooks: null,
        allOnlineExhibitions: null,
        article: {},
        onlineExhibition: {},
    },
    mutations: {
        setAllArticles(state, data) {
            if (data && Object.keys(data).length > 0 && data.data.length > 0) {
                data.data = data.data.map(article => {
                        article.article_date_th = DateFormatUtil.dateTh(article.article_date);
                        article.article_date_en = moment(article.article_date).format('DD MMM YYYY')
                    return article;
                });
            }
            state.allArticles = data;
        },
        setAllEbooks(state, data) {
            if (data && Object.keys(data).length > 0 && data.data.length > 0) {
                data.data = data.data.map(article => {
                    article.article_date_th = DateFormatUtil.dateTh(article.article_date);
                    article.article_date_en = moment(article.article_date).format('DD MMM YYYY')
                    return article;
                });
            }
            state.allEbooks = data;
        },
        setAllOnlineExhibitions(state, data) {
            state.allOnlineExhibitions = data;
        },
        setArticle(state, data) {
            if (data) {
                data.article_date_th = DateFormatUtil.dateTh(data.article_date);
                data.article_date_en = moment(data.article_date).format('DD MMM YYYY')
            }
            state.article = data;
        },
        setOnlineExhibition(state, data) {
            state.onlineExhibition = data;
        },
        clearArticle (state) {
            state.article = {}
        }
    },
    actions: {
        onGetAllCategories ({ commit }) {
            return Service.ArticleAPI.getAllCategories().then(res => {
                if (res.status == 200) {
                    return res.data
                }
                return false
            });
        },
        onGetAllArticles({commit}, data) {
            return Service.ArticleAPI.getAllArticles(data).then(res => {
                if (res.status == 200) {
                    commit('setAllArticles', res.data);
                }
            });
        },
        onGetAllEbooks({commit}, {page, lang}) {
            return Service.ArticleAPI.getAllEbooks({page, lang}).then(res => {
                if (res.status == 200) {
                    commit('setAllEbooks', res.data);
                } else {
                    commit('setAllEbooks', null);
                }
                return res;
            });
        },
        onGetAllOnlineExhibitions({commit}, {branch, page, lang}) {
            return Service.ArticleAPI.getAllOnlineExhibitions({branch, page, lang}).then(res => {
                if (res.status == 200) {
                    commit('setAllOnlineExhibitions', res.data);
                }
            });
        },
        onGetArticleById({commit}, {id, lang}) {
            return Service.ArticleAPI.getArticleById({id, lang}).then(res => {
                if (res.status == 200) {
                    commit('setArticle', res.data);
                }
            });
        },
        onCountArticleView({commit}, id) {
            return Service.ArticleAPI.countArticleView(id);
        },
        onGetOnlineExhibitionsById({commit}, {id, lang}) {
            return Service.ArticleAPI.getOnlineExhibitionsById({id, lang}).then(res => {
                if (res.status == 200) {
                    commit('setOnlineExhibition', res.data);
                }
            });
        }
    },
};

export default Article
